import { QuestionTooltip } from '@snack-uikit/tooltip';
import { Typography } from '@snack-uikit/typography';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ObjectDecorator(_ref) {
  var label = _ref.label,
    labelTooltip = _ref.labelTooltip,
    labelTooltipPlacement = _ref.labelTooltipPlacement;
  return /*#__PURE__*/_jsxs("span", {
    className: styles.title,
    children: [/*#__PURE__*/_jsx(Typography.SansTitleM, {
      children: label
    }), labelTooltip && /*#__PURE__*/_jsx("span", {
      className: styles.tipWrapperInline,
      children: /*#__PURE__*/_jsx(QuestionTooltip, {
        placement: labelTooltipPlacement,
        "data-pointer": true,
        tip: labelTooltip,
        size: "s",
        tabIndex: -1
      })
    })]
  });
}